import styled from 'styled-components';

export const BoxWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(to bottom right, #242a33, #1a1f26)'
    : 'linear-gradient(to bottom right, #e6f2f2, #FFF8F3)')};
  padding: 1.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#1a4d4d' : '#96c8c8')};
`;

export const AnimatedGradient = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 6px;
  opacity: 0.5;
  
  @keyframes gradientShift {
    0%, 100% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

export const GradientInner = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to right, #4d9e9e, #4d9e9e, #4d9e9e);
  filter: blur(4px);
  animation: gradientShift 3s ease-in-out infinite;
`;

export const Content = styled.div`
  position: relative;
  z-index: 10;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const IconWrapper = styled.div`
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 6px;
  background: linear-gradient(to bottom right, #4d9e9e, #0f3333);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px -1px rgba(224, 123, 45, 0.3);
`;

export const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1f2937')};
  margin-bottom: 0.25rem;
`;

export const Description = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#4b5563')};
  line-height: 1.5;
`;

export const TipsList = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const TipItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#374151')};
`;

export const TipBullet = styled.div`
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 9999px;
  background-color: #1a4d4d;
  margin-top: 0.375rem;
  flex-shrink: 0;
`;

export const DecorativeOrb = styled.div`
  position: absolute;
  top: -2rem;
  right: -2rem;
  width: 6rem;
  height: 6rem;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(to bottom right, rgba(224, 123, 45, 0.15), rgba(197, 106, 37, 0.15))'
    : 'linear-gradient(to bottom right, rgba(224, 123, 45, 0.1), rgba(253, 203, 158, 0.15))')};
  border-radius: 9999px;
  filter: blur(2rem);
`;
